<template>
  <div class="bet-page">
    <div class="page-header">
      <div class="page-header-inner">
        <button class="back-btn" type="button" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left"></i>
        </button>
        <div class="page-title">{{ $t('Betting Record') }}</div>
      </div>
    </div>

    <div class="sticky-panel">
      <div class="date-filter">
        <button type="button" class="date-item" :class="{ active: date == 1 }" @click="selectDate(1)">{{ $t('Today') }}</button>
        <button type="button" class="date-item" :class="{ active: date == 5 }" @click="selectDate(5)">{{ $t('Yesterday') }}</button>
        <button type="button" class="date-item" :class="{ active: date == 6 }" @click="selectDate(6)">{{ $t('This Week') }}</button>
        <button type="button" class="date-item" :class="{ active: date == 7 }" @click="selectDate(7)">{{ $t('Last Week') }}</button>
      </div>

      <div class="total-info">
        <div class="total-item">
          <span class="total-label">{{ $t('Total (Bets)') }}</span>
          <span class="total-value">{{ totalBets }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">{{ $t('Valid Bet') }}</span>
          <span class="total-value">{{ currencySymbol }}{{ validBet | vnd }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">{{ $t('Win/Loss') }}</span>
          <span class="total-value" :class="pnlClass(winLoss)">{{ formatPnl(winLoss) }}</span>
        </div>
      </div>
    </div>

    <div class="list-wrap">
      <div class="game-list" v-if="gameList.length > 0">
        <div class="game-item" v-for="game in gameList" :key="game.name">
          <div class="game-main">
            <div class="game-name">{{ game.name }}</div>
            <div class="game-bet">{{ $t('Valid Bet') }} {{ currencySymbol }}{{ game.validBet | vnd }}</div>
          </div>
          <div class="game-side">
            <div class="game-win-loss" :class="pnlClass(game.winLoss)">{{ formatPnl(game.winLoss) }}</div>
            <div class="game-bets">{{ game.bets }}{{ $t('bets') }}</div>
          </div>
        </div>
      </div>
      <div class="empty-box" v-else-if="!loading">
        <p>{{ $t('No betting records') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatVnd } from '@/utils/currency';

export default {
  name: 'betRecord',
  data() {
    return {
      date: 1,
      list: [],
      pageData: {},
      loading: false,
      totalBets: 0,
      validBet: 0,
      winLoss: 0,
      gameList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    pnlClass(value) {
      const n = Number(value) || 0;
      if (n < 0) return 'negative';
      if (n > 0) return 'positive';
      return '';
    },
    formatPnl(value) {
      const n = Number(value) || 0;
      const text = formatVnd(Math.abs(n));
      if (n > 0) return `+${this.currencySymbol}${text}`;
      if (n < 0) return `-${this.currencySymbol}${text}`;
      return `${this.currencySymbol}${text}`;
    },
    selectDate(val) {
      this.date = val;
      this.getData();
    },
    getData() {
      const that = this;
      that.loading = true;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/betrecord', {
          date: that.date,
          page: 1,
          api_type: '',
          pagesize: 500,
        })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
            that.gameList = [];
            that.totalBets = 0;
            that.validBet = 0;
            that.winLoss = 0;
          } else {
            that.pageData = res.data;
            that.list = res.data.data || [];
            that.calculateGameStats(that.list);
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.loading = false;
          that.$parent.hideLoading();
        });
    },
    calculateGameStats(data) {
      this.totalBets = 0;
      this.validBet = 0;
      this.winLoss = 0;
      const gameGroups = {};

      (data || []).forEach(item => {
        this.totalBets += 1;
        const betAmount = parseFloat(item.bet_amount) || 0;
        const winLoss = parseFloat(item.win_loss) || 0;
        this.validBet += betAmount;
        this.winLoss += winLoss;

        const gameName = item.Code || item.platform_type || this.$t('Other');
        if (!gameGroups[gameName]) {
          gameGroups[gameName] = {
            name: gameName,
            validBet: 0,
            winLoss: 0,
            bets: 0,
          };
        }
        gameGroups[gameName].validBet += betAmount;
        gameGroups[gameName].winLoss += winLoss;
        gameGroups[gameName].bets += 1;
      });

      this.gameList = Object.values(gameGroups)
        .filter(game => game.bets > 0)
        .sort((a, b) => b.validBet - a.validBet);
    },
  },
};
</script>

<style lang="scss" scoped>
.bet-page {
  min-height: 100vh;
  background: #f7f3ec;
  color: #352b24;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #1f3b6d;
}
.page-header-inner {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.back-btn {
  position: absolute;
  left: 8px;
  top: 0;
  height: 46px;
  width: 44px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 18px;
}
.page-title {
  color: #fff;
  font-size: 17px;
  font-weight: 700;
}

.sticky-panel {
  position: sticky;
  top: 46px;
  z-index: 10;
  padding: 12px 14px 10px;
  background: #f7f3ec;
}

.date-filter {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
.date-item {
  flex: 1;
  height: 36px;
  border: 1px solid #ead1b2;
  border-radius: 20px;
  background: #fff;
  color: #8a6a4a;
  font-size: 13px;
  font-weight: 600;
  &.active {
    background: linear-gradient(135deg, #ffe082, #d1a03e);
    border-color: #d1a03e;
    color: #4a2e00;
  }
}

.total-info {
  display: flex;
  background: #fff;
  border: 1px solid #eadfd3;
  border-radius: 14px;
  padding: 14px 6px;
  box-shadow: 0 4px 14px rgba(117, 73, 34, 0.06);
}
.total-item {
  flex: 1;
  text-align: center;
}
.total-label {
  display: block;
  font-size: 11px;
  color: #8a6a4a;
  margin-bottom: 6px;
}
.total-value {
  display: block;
  font-size: 15px;
  font-weight: 800;
  color: #352b24;
  font-variant-numeric: tabular-nums;
  &.positive { color: #2e7d32; }
  &.negative { color: #c0392b; }
}

.list-wrap {
  padding: 0 14px 28px;
}
.game-list {
  background: #fff;
  border: 1px solid #eadfd3;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(117, 73, 34, 0.06);
}
.game-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f3e6d6;
  &:last-child { border-bottom: 0; }
}
.game-name {
  font-size: 15px;
  font-weight: 700;
  color: #352b24;
  margin-bottom: 4px;
}
.game-bet {
  font-size: 12px;
  color: #8a6a4a;
}
.game-side {
  text-align: right;
  flex-shrink: 0;
}
.game-win-loss {
  font-size: 15px;
  font-weight: 800;
  color: #352b24;
  font-variant-numeric: tabular-nums;
  &.positive { color: #2e7d32; }
  &.negative { color: #c0392b; }
}
.game-bets {
  margin-top: 4px;
  font-size: 12px;
  color: #8a6a4a;
}

.empty-box {
  margin-top: 48px;
  text-align: center;
  color: #8a6a4a;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/betRecord.vue